import { LearnableResponse } from 'src/types/domain';

const getLearnableTitles = (toLearn: string, toPronounce: (string | null)[]): string[] => {
  return [
    toLearn,
    ...toPronounce.filter((pronunciation): pronunciation is string => {
      return !!pronunciation && pronunciation !== toLearn;
    }),
  ];
};

export const getLearnableTitlesByTargetLang = (
  {
    kana,
    romanization,
    targetValue,
  }: Pick<LearnableResponse, 'targetValue' | 'kana' | 'romanization'>,
  targetLanguage: string,
): string[] => {
  switch (targetLanguage) {
    case 'jp-romaji':
      return [romanization || targetValue];

    case 'jp-full':
      return getLearnableTitles(targetValue, [kana, romanization]);

    case 'fa':
    case 'he':
    case 'hi':
    case 'th':
    case 'zh-cn':
      return getLearnableTitles(targetValue, [romanization]);

    default:
      return [targetValue];
  }
};
